import { Axios } from '../axios'

const getInvoicesReceived = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/invoice-received?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

const getInvoicesReceivedByVendor = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/invoice-received/by-customer/${payload.id}?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

const updateInvoiceReceived = async (payload) => {
  const { data } = await Axios.post(
    '/invoice-received/' + payload.id,
    payload.data,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 0,
    }
  )
  return data
}

const getInvoiceReceived = async (payload) => {
  const { data } = await Axios.get('/invoice-received/' + payload)
  return data?.data
}

const createSingleInvoiceReceived = async (payload) => {
  const { data } = await Axios.post('/invoice-received', payload, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
  })
  return data
}

const markInvoiceReceivedPaid = async (payload) => {
  const { data } = await Axios.post(
    `/invoice-received/${payload.id}/mark-as-paid`,
    payload.data
  )
  return data
}

const deleteInvoiceReceived = async (payload) => {
  const { data } = await Axios.delete('invoice-received/' + payload)
  return data
}

const getInvoicesReceivedPayments = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''
  const { data } = await Axios.get(
    `/invoice-received/payments/${payload.id}?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

const initiateInvoicePayment = async (payload) => {
  const { data } = await Axios.post(
    `/invoice-received/payment/initiate/${payload.id}`,
    payload.data
  )
  return data
}

const disburseInvoicePayment = async (payload) => {
  const { data } = await Axios.post(
    `/invoice-received/payment/disburse/${payload.id}`,
    payload.data
  )
  return data
}

const declineInvoicePayment = async (payload) => {
  const { data } = await Axios.post(
    `/invoice-received/payment/decline/${payload.id}`,
    payload.data
  )
  return data
}

const getInvoicePaymentsSummary = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''

  const { data } = await Axios.get(
    `/invoice-received/payments/history?limit=${payload.limit}&page=${payload.page}${filter}${search}`
  )
  return data?.data
}

const fetchVendorInvoicePayById = async (payload) => {
  const { data } = await Axios.get(
    `/invoice-received/payment/${payload.id}?limit=${payload.limit}&page=${payload.page}`
  )
  const totalPayable = (
    parseFloat(data?.data?.total_amount) + parseFloat(data?.data?.trans_cost)
  ).toFixed(2)

  if (data.data) {
    data.data.transactions.total_net_pay = data?.data.total_amount
    data.data.transactions.total_payable = totalPayable
    data.data.transactions.total_trans_cost = data?.data.trans_cost
    // Add the vendor information to transactions so it's accessible
    data.data.transactions.vendor = data?.data.vendor
    data.data.transactions.vendor_email = data?.data.vendor_email
    data.data.transactions.vendor_mobile = data?.data.vendor_mobile

    // Also add other main level data you might need
    data.data.transactions.invoice_number = data?.data.invoice_number
    data.data.transactions.bank = data?.data.bank
    data.data.transactions.account_number = data?.data.account_number
  }
  return {
    transactions: data?.data.transactions,
    mainData: {
      vendor: data?.data.vendor,
      vendor_email: data?.data.vendor_email,
      vendor_mobile: data?.data.vendor_mobile,
      invoice_number: data?.data.invoice_number,
      total_amount: data?.data.total_amount,
      amount_paid: data?.data.amount_paid,
      bank: data?.data.bank,
      account_number: data?.data.account_number,
      status: data?.data.status,
      processed: data?.data.processed,

      created: data?.data.created,
    },
  }
}

export const invoices_received = {
  getInvoicesReceived,
  getInvoicesReceivedByVendor,
  updateInvoiceReceived,
  getInvoiceReceived,
  createSingleInvoiceReceived,
  markInvoiceReceivedPaid,
  deleteInvoiceReceived,
  getInvoicesReceivedPayments,

  initiateInvoicePayment,
  disburseInvoicePayment,
  declineInvoicePayment,
  getInvoicePaymentsSummary,
  fetchVendorInvoicePayById,
}
